// extracted by mini-css-extract-plugin
module.exports = {"collapsableHeader":"collapsableHeader___fy+Wx","headerHeader":"headerHeader___mxkPR","image":"image___Ag9pL","headerText":"headerText___gq3aW","collapsed":"collapsed___tT2wb"};